import React, { useState, useEffect } from 'react';

// Import images for hero carousel
import executiveTeam from '../assets/executive-team1.jpg';
import aiAutomation from '../assets/ai-automation1.jpg';
import digitalAgency from '../assets/digital-agency1.jpg';

const Hero = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      id: 1,
      title: "Professional Excellence",
      description: "Elite executive talent driving your success",
      image: executiveTeam,
      overlay: "bg-blue-900/40"
    },
    {
      id: 2,
      title: "AI & Automation",
      description: "Intelligent systems transforming your workflow",
      image: aiAutomation,
      overlay: "bg-blue-600/30"
    },
    {
      id: 3,
      title: "Digital Agency Trust",
      description: "Beautiful designs for New York businesses",
      image: digitalAgency,
      overlay: "bg-cyan-500/30"
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [slides.length]);

  const scrollToServices = () => {
    document.getElementById('services').scrollIntoView({ behavior: 'smooth' });
  };

  const goToPreviousSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  const goToNextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  return (
    <section id="hero" className="min-h-screen bg-white flex items-center py-20 px-4 pt-24 lg:pt-32">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        {/* Left Text Content */}
        <div className="lg:pr-8">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight mb-6">
            Empower Your Business.{' '}
            <span className="bg-gradient-to-r from-blue-600 to-cyan-500 bg-clip-text text-transparent">
              Limitlessly.
            </span>
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed">
            Where Elite Talent Meets Intelligent Automation & Trusted Digital Design.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
            <button className="bg-gradient-to-r from-blue-600 to-cyan-500 hover:from-blue-700 hover:to-cyan-600 text-white font-semibold py-4 px-8 rounded-lg transition-all duration-300 transform hover:-translate-y-1 hover:shadow-2xl shadow-lg">
              Start Your Free Demo
            </button>
            <button 
              onClick={scrollToServices}
              className="text-blue-600 hover:text-blue-800 font-semibold py-4 px-6 transition-all duration-300 transform hover:-translate-y-1"
            >
              Explore Our Services ↓
            </button>
          </div>
        </div>

        {/* Right Carousel with Images */}
        <div className="relative h-96 lg:h-[500px] rounded-2xl overflow-hidden shadow-2xl">
          <div className="relative w-full h-full">
            {slides.map((slide, index) => (
              <div
                key={slide.id}
                className={`absolute inset-0 transition-opacity duration-1000 ease-in-out ${
                  index === currentSlide ? 'opacity-100' : 'opacity-0'
                }`}
              >
                {/* Background Image */}
                <img 
                  src={slide.image} 
                  alt={slide.title}
                  className="w-full h-full object-cover"
                />
                
                {/* Overlay */}
                <div className={`absolute inset-0 ${slide.overlay}`}></div>
                
                {/* Content */}
                <div className="absolute inset-0 flex items-center justify-between p-8 text-white">
                  <div className="max-w-xs">
                    <h3 className="text-2xl font-bold mb-3">{slide.title}</h3>
                    <p className="text-blue-100">{slide.description}</p>
                  </div>
                  {/* <div className="w-48 h-48 bg-white/20 rounded-2xl backdrop-blur-sm flex items-center justify-center text-lg font-semibold border border-white/30">
                    <div className="text-center">
                      <div className="text-3xl mb-2">
                        {slide.id === 1 && "👥"}
                        {slide.id === 2 && "🤖"}
                        {slide.id === 3 && "💻"}
                      </div>
                      <div className="text-sm">Featured</div>
                    </div>
                  </div> */}
                </div>
              </div>
            ))}
          </div>
          
          {/* Navigation Arrows - Moved to Bottom */}
          <div className="absolute bottom-4 left-4 right-4 flex justify-between items-center">
            {/* Left Arrow */}
            <button 
              onClick={goToPreviousSlide}
              className="bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-3 transition-all duration-300 hover:scale-110 border border-white/30"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            {/* Carousel Indicators - Centered */}
            <div className="flex gap-3">
              {slides.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentSlide(index)}
                  className={`w-3 h-3 rounded-full transition-all duration-300 ${
                    index === currentSlide 
                      ? 'bg-white scale-125' 
                      : 'bg-white/50 hover:bg-white/80'
                  }`}
                />
              ))}
            </div>

            {/* Right Arrow */}
            <button 
              onClick={goToNextSlide}
              className="bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full p-3 transition-all duration-300 hover:scale-110 border border-white/30"
            >
              <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;